import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  people: [],
  peopleFetching: false,
  isCreatingPerson: false,
  dealerId: null,
  person: null,
  personFetching: false
}

const createPeopleSlice = (set, get) => ({
  ...initialState,
  fetchPeople: async(dealerId) => {
    set((state) => ({ peopleFetching: true}))

    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/people`,
        {headers: get().requestHeaders}
      )
      if (response.status === 200) {
        const data = await response.json()

        if(get().user) {
          set((state) => ({ people: data.data, peopleFetching: false }))
        }
      }
    } catch (err) {
      get().logError('There was an error fetching people data.', err)
    }
  },
  fetchPerson: async(dealerId, personId) => {
    set((state) => ({ personFetching: true}))

    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/people/${personId}`,
        {headers: get().requestHeaders}
      )
      if (response.status === 200) {
        const data = await response.json()
        if(get().user) {
          set((state) => ({ person: data.data, personFetching: false }))
        }
      }
    } catch (err) {
      get().logError('There was an error fetching person data.', err)
    }
  },
  updatePerson: async (dealerId, personId, attributes) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/people/${personId}`,
        {
          headers: get().requestHeaders,
          method: 'PATCH',
          body: JSON.stringify({
            person: attributes
          })
        }
      )
      if (response.status === 200) {
        const data = await response.json()

        if(get().user) {
          set((state) => ({ person: data.data }))
        }
      }
    } catch (err) {
      get().logError('There was an error updating a person.', err)
    }
  },
  createPerson: async (dealerId, body) => {
    set(() => ({ isCreatingPerson: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/people`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify({ person: body })
        }
      )
      const data = await response.json()

      if (response.ok) {
        get().setSuccessMessage('Person successfully created')
        get().fetchPeople(dealerId)
      } else {
        get().setErrMessage(data.errors?.[0] || 'Unable to create person')
      }
    } catch (err) {
      get().logError('There was an error creating this person.', err)
    } finally {
      set(() => ({ isCreatingPerson: false }))
    }
  },
  setDealerId: (id) => set(() => ({ dealerId: id })),
  resetPeopleSlice: () => set(initialState)
})

export default createPeopleSlice